import Card from "react-bootstrap/Card";
// import { CardContent } from "@mui/material";
import PopupModal from "../../../components/Modal/PopupModal";
import { useState } from "react";
import { Row, Col } from "react-bootstrap";

const GetIntouchCard = ({ getInTouchData }) => {
  const [getPopUpShow, setPopUpShow] = useState(false);

  const onhide = () => {
    setPopUpShow(false);
  };
  const handelclick = () => {
    setPopUpShow(true);
  };
  return (
    <>
      <PopupModal show={getPopUpShow} onHide={onhide} />
      <Row className="container">
        {getInTouchData.map((data, i) => (
          <>
            <Col
              className="mb-4 d-flex justify-content-center"
              key={i}
              xs={12}
              md={4}
              lg={4}
            >
              <Card className="me-4" style={{ width: "22rem" }}>
                <Card.Body>
                  <p className="cardtitle">{data.heading}</p>
                  <p>{data.content}</p>
                  <div>
                    <button
                      className="main-btn text-center"
                      onClick={handelclick}
                    >
                      Book a Demo
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </>
        ))}
      </Row>
    </>
  );
};
export default GetIntouchCard;
